import { createContext } from "react";
import useLocalStorageState from "../hooks/useLocalStorageState";

export const SeggreagtionContext = createContext();

const SeggregationProvider = ({ children }) => {
  const [segg_selectedCategory, segg_setSelectedCategory] =
    useLocalStorageState("segg_selectedCategory", "");
  const [segg_selectedSubCategory, segg_setSelectedSubCategory] =
    useLocalStorageState("segg_selectedSubCategory", "");
  const [segg_selectedMarketplace, segg_setSelectedMarketplace] =
    useLocalStorageState("segg_selectedMarketplace", "");
  const [segg_selectedVariant, segg_setSelectedVariant] = useLocalStorageState(
    "segg_selectedVariant",
    ""
  );
  const [segg_queryParams, seggg_setQueryParams] = useLocalStorageState(
    "segg_queryParams",
    ""
  );
  const [segg_logoutPayload, segg_setLogoutPayload] = useLocalStorageState(
    "segg_logPayload",
    ""
  );

  return (
    <SeggreagtionContext.Provider
      value={{
        segg_selectedCategory,
        segg_setSelectedCategory,
        segg_selectedSubCategory,
        segg_setSelectedSubCategory,
        segg_selectedMarketplace,
        segg_setSelectedMarketplace,
        segg_selectedVariant,
        segg_setSelectedVariant,
        segg_queryParams,
        seggg_setQueryParams,
        segg_logoutPayload,
        segg_setLogoutPayload,
      }}
    >
      {children}
    </SeggreagtionContext.Provider>
  );
};

export default SeggregationProvider;
